import React from 'react';
import { Image, View, StyleSheet } from 'react-native';
import CardFactory from './CardFactory';
import { Credential } from '../../../../types/credentials';
import { cardBackgroundRevoked } from '../../../../data/credentials/background';

/**
 * @description Card background component
 * @param {Credential} credential
 * @return {React.FC}
 */
const CardBackground: React.FC<{ credential: Credential }> = ({ credential }) => {
  const uri = CardFactory.createBackground(credential);
  return (
    <View style={styles.container}>
      <Image source={{ uri: uri }} style={styles.background} />
      {credential.revoked && (
        <Image
          source={{ uri: cardBackgroundRevoked }}
          style={[styles.background, styles.revokedOverlay]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  background: {
    width: '100%',
    height: '100%',
    position: 'absolute'
  },
  revokedOverlay: {
    opacity: 0.5 // Adjust opacity to your liking
  }
});
export default CardBackground;
